import ClientInstance from '../ClientInstance';
import { isTeacher } from 'lib/helpers';
import { localeFlag } from '../ApiHelpers';

export interface ICentersOrgOwners {
  postCenter?: any;
  getCenter?: any;
  getGroupsByCenter?: any;
  putCenter?: any;
  getCenters?: any;
  deleteCenter?: any;
  postTeacher?: any;
  putTeacher?: any;
  deleteTeacher?: any;
  getGroupList?: any;
  getUserCenter?: any;
  deleteGroup?: any;
  getMyGroupList?: any;
  updateTeacherPermission?: any;
}

export interface ICentersOrgAdmins {
  postCenter?: any;
  getCenters?: any;
  getGroupsByCenter?: any;
  putTeacher?: any;
  postTeacher?: any;
  getGroupList?: any;
  getUserCenter?: any;
  deleteGroup?: any;
  deleteCenter?: any;
  getCenter?: any;
  putCenter?: any;
  deleteTeacher?: any;
  getMyGroupList?: any;
  updateTeacherPermission?: any;
}

export interface ICentersOrgTeachers {
  postCenter?: any;
  getCenters?: any;
  postTeacher?: any;
  putTeacher?: any;
  getGroupList?: any;
  getMyGroupList?: any;
  getUserCenter?: any;
  deleteGroup?: any;
  deleteTeacher?: any;
}

export interface ICentersOrgShared {
  deleteGroup?: any;
}

export interface ICentersCenterTeachers {
  putTeacher?: any
}

interface ICentersCenters {
  teachers: ICentersCenterTeachers;
}

interface ICentersOrg {
  owners: ICentersOrgOwners;
  admins: ICentersOrgAdmins;
  directors: ICentersOrgAdmins;
  teachers: ICentersOrgTeachers;
  shared: ICentersOrgShared;
}

const organizations: ICentersOrg = {
  owners: {
    postCenter: (body: any) => ClientInstance.post('/organizations/owners/centers/', body),
    getCenter: (centerId: number) => ClientInstance.get(`/organizations/owners/centers/${centerId}`),
    getGroupsByCenter: (centerId: number) => ClientInstance.get(`/organizations/owners/centers/${centerId}/groups`),
    getGroupList: () => ClientInstance.get(`/centers/shared/groups`),
    putCenter: (centerId: number, body: any) => ClientInstance.put(`/organizations/owners/centers/${centerId}`, body),
    getCenters: () => ClientInstance.get('/organizations/owners/centers/'),
    deleteCenter: (centerId: any) => ClientInstance.delete(`/organizations/owners/centers/${centerId}`),
    postTeacher: (centerId: number, body: any) => ClientInstance.post(`/organizations/owners/centers/${centerId}/teachers`, body),
    putTeacher: (body: any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/teachers/${teacherId}`, body),
    deleteTeacher: (centerId: number, teacherId: number) => ClientInstance.delete(`/organizations/owners/centers/${centerId}/teachers/${teacherId}`),
    updateTeacherPermission: (body:any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/users/${teacherId}/permission`, body),
    getUserCenter: () => ClientInstance.get('/centers/shared/teachers'),
    deleteGroup: (centerId: number, groupId: number) => ClientInstance.delete(`/organizations/shared/centers/${centerId}/groups/${groupId}?${localeFlag()}`),
  },
  admins: {
    postCenter: (body: any) => ClientInstance.post('/organizations/admins/centers/', body),
    getCenters: () => ClientInstance.get('/organizations/admins/centers/'),
    getGroupsByCenter: (centerId: number) => ClientInstance.get(`/organizations/owners/centers/${centerId}/groups`),
    postTeacher: (centerId: number, body: any) => ClientInstance.post(`/organizations/admins/centers/${centerId}/teachers`, body),
    getGroupList: () => ClientInstance.get(`/centers/shared/groups`),
    getUserCenter: () => ClientInstance.get('/centers/shared/teachers'),
    deleteGroup: (centerId: number, groupId: number) => ClientInstance.delete(`/organizations/shared/centers/${centerId}/groups/${groupId}?${localeFlag()}`),
    deleteCenter: (centerId: any) => ClientInstance.delete(`/organizations/admins/centers/${centerId}`),
    getCenter: (centerId: number) => ClientInstance.get(`/organizations/admins/centers/${centerId}`),
    putCenter: (centerId: number, body: any) => ClientInstance.put(`/organizations/admins/centers/${centerId}`, body),
    putTeacher: (body: any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/teachers/${teacherId}`, body),
    updateTeacherPermission: (body:any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/users/${teacherId}/permission`, body),
    deleteTeacher: (centerId: number, teacherId: number) => ClientInstance.delete(`/organizations/owners/centers/${centerId}/teachers/${teacherId}`),
  },
  directors: {
    postCenter: (body: any) => ClientInstance.post('/organizations/admins/centers/', body),
    getCenters: () => ClientInstance.get('/organizations/admins/centers/'),
    getGroupsByCenter: (centerId: number) => ClientInstance.get(`/organizations/owners/centers/${centerId}/groups`),
    postTeacher: (centerId: number, body: any) => ClientInstance.post(`/organizations/admins/centers/${centerId}/teachers`, body),
    getGroupList: () => ClientInstance.get(`/centers/shared/groups`),
    getUserCenter: () => ClientInstance.get('/centers/shared/teachers'),
    deleteGroup: (centerId: number, groupId: number) => ClientInstance.delete(`/organizations/shared/centers/${centerId}/groups/${groupId}?${localeFlag()}`),
    deleteCenter: (centerId: any) => ClientInstance.delete(`/organizations/admins/centers/${centerId}`),
    getCenter: (centerId: number) => ClientInstance.get(`/organizations/admins/centers/${centerId}`),
    putCenter: (centerId: number, body: any) => ClientInstance.put(`/organizations/admins/centers/${centerId}`, body),
    putTeacher: (body: any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/teachers/${teacherId}`, body),
    updateTeacherPermission: (body:any, centerId: number, teacherId: number) => ClientInstance.put(`/organizations/shared/centers/${centerId}/users/${teacherId}/permission`, body),
    deleteTeacher: (centerId: number, teacherId: number) => ClientInstance.delete(`/organizations/owners/centers/${centerId}/teachers/${teacherId}`),
  },
  teachers: {
    postCenter: (body: any) => ClientInstance.post('/organizations/teachers/centers/', body),
    getCenters: () => ClientInstance.get('/organizations/teachers/centers/'),
    postTeacher: (centerId: number, body: any) => ClientInstance.post(`/organizations/teachers/centers/${centerId}/teachers`, body),
    getGroupList: () => ClientInstance.get(`/centers/shared/groups`),
    getMyGroupList: () => ClientInstance.get(`/centers/shared/teachers/${localStorage.getItem('user_id')}/groups`),
    getUserCenter: () => ClientInstance.get('/centers/shared/teachers'),
    deleteGroup: (centerId: number, groupId: number) => ClientInstance.delete(`/organizations/shared/centers/${centerId}/groups/${groupId}?${localeFlag()}`),
    deleteTeacher: (centerId: number, teacherId: number) => ClientInstance.delete(`/organizations/owners/centers/${centerId}/teachers/${teacherId}`),
  },
  shared: {
    deleteGroup: (centerId: number, groupId: number) => {
      if (isTeacher()) {
        return ClientInstance.delete(`/centers/shared/groups/${groupId}?${localeFlag()}`)
      }
      return ClientInstance.delete(`/organizations/shared/centers/${centerId}/groups/${groupId}?${localeFlag()}`)
    },
  },
};

const centers: ICentersCenters = {
  teachers: {
    putTeacher: (teacherId: number, body: any) => ClientInstance.put(`/centers/shared/teachers/${teacherId}`, body),
  },
};

export default {
  organizations,
  centers,
};
